import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { editDeal, deleteDeal } from '../../actions/deal';
import PropTypes from 'prop-types';
import { makeStyles, Icon, Link } from '@material-ui/core';
import moment from 'moment';

const initialState = {
  _id: '',
  contact: '',
  name: '',
  amount: '',
  note: '',
  time: ''
};

const OneDeal = ({ deal, editDeal, deleteDeal }) => {
  const useStyles = makeStyles(theme => ({
    dealContainer: {
      background: '#F2F4F4',
      marginBottom: '10px'
    },
    newDealBody: {
      padding: '5px',
      background: '#F2F4F4'
    },
    dealNameDiv: {
      background: '#D5D8DC',
      display: 'flex'
    },
    dealNameHead: {
      padding: '5px',
      width: '40%'
    },
    deleteIcon: {
      paddingTop: '5px',
      marginLeft: '55%'
    },
    editIcon: {
      paddingTop: '5px',
      marginLeft: '1%'
    },
    dealFooter: {
      margin: '5px',
      display: 'flex'
    },
    timeLine: {
      paddingTop: '2px'
    },
    noteBody: {
      margin: '15px 0 5px 5px'
    }
  }));
  const classes = useStyles();
  const [clickEdit, setClickEdit] = useState(false);
  const [formDataEdit, setFormDataEdit] = useState(initialState);

  const onClickDelete = deal => {
    deleteDeal(deal.deal, deal.deal._id);
  };

  const onClickEdit = deal => {
    if (deal.deal) {
      const dealData = { ...initialState };
      for (const key in deal.deal) {
        if (key in dealData) dealData[key] = deal.deal[key];
      }
      setFormDataEdit(dealData);
    }
    setClickEdit(true);
  };

  const onClickEditCancel = e => {
    e.preventDefault();
    setClickEdit(false);
  };
  const { name, amount, note } = formDataEdit;

  const onChangeInputEdit = e =>
    setFormDataEdit({ ...formDataEdit, [e.target.name]: e.target.value });

  const onSubmitEdit = e => {
    e.preventDefault();
    formDataEdit.contactID = formDataEdit.contact;
    editDeal(formDataEdit, formDataEdit._id);
    setClickEdit(false);
  };
  return (
    <Fragment>
      <div className={classes.dealContainer}>
        <div className={classes.dealNameDiv}>
          <div className={classes.dealNameHead}>
            <h4>
              <i class='fas fa-bars'></i> {deal.name}
            </h4>
          </div>
          <div className={classes.deleteIcon}>
            <Icon
              className='fas fa-trash-alt'
              style={{ color: '#333', fontSize: 15 }}
              onClick={e => onClickDelete({ deal })}
            ></Icon>
          </div>
          <div className={classes.editIcon}>
            {clickEdit ? (
              <Icon
                className='fas fa-times'
                style={{ color: '#333', fontSize: 15 }}
                onClick={e => onClickEditCancel(e)}
              ></Icon>
            ) : (
              <Icon
                className='fas fa-pen'
                style={{ color: '#333', fontSize: 15 }}
                onClick={e => onClickEdit({ deal })}
              ></Icon>
            )}
          </div>
        </div>

        <div className={classes.dealFooter}>
          <h3>
            <i class='fas fa-dollar-sign'></i> {`${deal.amount}`} &nbsp; |
          </h3>
          <p className={classes.timeLine}>
            &nbsp; This deal should end before &nbsp; &nbsp;
            {moment(deal.time).format('ll')}
          </p>
        </div>
        <div className={classes.noteBody}>
          <p>Note: {deal.note}</p>
        </div>
      </div>
      <Fragment>
        {clickEdit && (
          <Fragment>
            <div className={classes.newDealBody}>
              <h3>Edit Deal</h3>{' '}
              <form className='na-form' onSubmit={e => onSubmitEdit(e)}>
                <div className='form-group'>
                  <input
                    type='text'
                    placeholder='Deal'
                    name='name'
                    value={name}
                    onChange={e => onChangeInputEdit(e)}
                    required
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='number'
                    placeholder='Amount'
                    name='amount'
                    value={amount}
                    onChange={e => onChangeInputEdit(e)}
                    required
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='text'
                    placeholder='Note'
                    name='note'
                    value={note}
                    onChange={e => onChangeInputEdit(e)}
                  />
                </div>
                <input type='submit' className='btn btn-firm' value='Save' />
                <Link href='#' onClick={e => onClickEditCancel(e)}>
                  Cancel
                </Link>
              </form>
            </div>
          </Fragment>
        )}
      </Fragment>
    </Fragment>
  );
};

OneDeal.propTypes = {
  deal: PropTypes.object.isRequired,
  editDeal: PropTypes.func.isRequired,
  deleteDeal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, { editDeal, deleteDeal })(OneDeal);



// WEBPACK FOOTER //
// ./src/components/deal/OneDeal.js